import { Route, Routes } from "react-router-dom";
import React from "react";
import ContractorDetails from "./ContractorDetails";
import FWBDetails from "./FWBDetails";
import Confirmation from "./Confirmation";

type Props = {
  onNext: VoidFunction | null;
  onPrevious: VoidFunction | null;
  onSubmit: VoidFunction | null;
};

const ContractorRoutes: React.FC<Props> = ({ onNext, onPrevious, onSubmit }) => (
  <Routes>
    <Route path="contractor-details" element={<ContractorDetails onNext={onNext} />} />
    <Route path="fwb-details" element={<FWBDetails onSubmit={onSubmit} onPrevious={onPrevious} />} />
    <Route path="success" element={<Confirmation />} />
  </Routes>
);

export default ContractorRoutes;
